import GradientTemperatureValid from './GradientTemperatureValid';

export default class GradientTemperature48 extends GradientTemperatureValid {
  constructor(rowIndex: number, temperature: number) {
    super(rowIndex, temperature, 8);
  }
}
